export default {
    strict: true,
    fields: {
        address: {
            type: "string",
        },
    },
};
